"use client";
import { Button } from "@/components/Core/Button";
import { DropDown } from "components/Core/DropDown";
import {
  buildAcademicCycleOptions,
  buildCalendarCycleOptions,
  validateNestedParams,
} from "helper/HelperFunction";
import { useState } from "react";
import { useSelector } from "react-redux";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./AddEditCycleModal.module.css";

export default function AddEditCycleModal({
  show,
  setShow,
  handleClick,
  modalLoading,
}) {
  const { user } = useSelector((state) => state.authReducer);
  const [name, setName] = useState(null);

  const handleValidate = () => {
    let params = {
      name: name.value,
    };
    if (!validateNestedParams(params)) return;
    handleClick(params);
  };

  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      header={"Add Cycle"}
      showCloseIcon={true}
      width={"600px"}
      modalClass={classes.modal_campus_manager}
    >
      <div className={classes.container}>
        <div className={classes.fields}>
          <DropDown
            options={
              user?.school?.cycleFormat == "calendar"
                ? calendarCycleOptions
                : academicCycleOptions
            }
            label={"Cycle"}
            placeholder={"Select Cycle"}
            value={name}
            setter={setName}
            menuPlacement={"bottom"}
          />
        </div>
        <div className={classes.button_container}>
          <Button
            label={modalLoading ? "Loading..." : "Create"}
            onClick={handleValidate}
            disabled={modalLoading}
          />
          <Button
            label={"Cancel"}
            onClick={() => setShow(false)}
            variant="secondary"
            disabled={modalLoading}
          />
        </div>
      </div>
    </ModalSkeleton>
  );
}

const calendarCycleOptions = buildCalendarCycleOptions();
const academicCycleOptions = buildAcademicCycleOptions();
